import instantNoodleTable from './blogs/instantNoodleTable.js'
import instantNoodleWall from './blogs/instantNoodleWall.js'
const blogList = [
  instantNoodleTable,
  instantNoodleWall
];

export default blogList;
